import React, { Component } from 'react';
import PropTypes from 'prop-types';
import SideBarToggle from '../../../components/AdminConfig/Content/SideBarToggle';
import EditPoi from '../../../components/AdminConfig/Content/editPoi';
import {BootstrapTable,TableHeaderColumn} from 'react-bootstrap-table';
import RCPagination from '../../UserControl/Pagination/RCPagination';
import { checkStatus } from '../../../../util/util';



class listPoi extends Component {

    constructor() {
        super();

        this.state = {
            dataPoi:[],
            poiName:'',
            deviceSelectID:null,
            isShowEdit:false,
            isShowNew:false,
            currentPage:1,
            currentPageSize:10,
            totalPage:0
        };
    }

    componentDidMount() {
        // this.getPOIList();
        this.onPageSizeChange(this.state.currentPage,this.state.currentPageSize);
    }

    componentWillUnmount() {
        this.setState({dataPoi: [], poiName: ''});
    }

    componentWillUnmount(){
    }

    onPageSelect(page){

        const name = this.state.poiName;
       const { currentPageSize } = this.state;
       const { user_id, user_name,token} = this.props;
       fetch(`http://203.150.199.244/api/admin/getPOIList/${page}/${currentPageSize}`, {
           method: 'post',
           headers: {
               "Content-Type": "application/json; charset=utf-8",
            //    "user_id": user_id,
            //    "user_name": user_name,
               "token": token
           },
           body: JSON.stringify({
               "filter":name
           })
           })
           .then(response => { return checkStatus(response)})
           .then(data => {
               this.setState({
                    dataPoi:data.RESULT_DATA,
                   totalPage:data.RESULT_TOTAL,
                   currentPage:page,currentPageSize:currentPageSize})

           })
           .catch(function (err) {
               console.log('err:', err);
               // POST failed...
           });
   
    }
    onPageSizeChange(page, pageSize){
        // fetch http://{server}/api/admin/xxxx/{page}/{this.state.currentPageSize}
        // then this.setState({deviceList:data,currentPage:page,currentPageSize:pageSize})


        const name = this.state.poiName;
        const { user_id, user_name,token} = this.props;

        fetch(`http://203.150.199.244/api/admin/getPOIList/${page}/${pageSize}`, {
            method: 'post',
            headers: {
                "Content-Type": "application/json; charset=utf-8",
            //    "user_id": user_id,
            //    "user_name": user_name,
               "token": token
            },
            body: JSON.stringify({
                "filter":name
            })
            })
            .then(response => { return checkStatus(response)})
            .then(data => {
                console.log(data.RESULT_DATA)
                this.setState(
                    {dataPoi:data.RESULT_DATA,
                    totalPage:data.RESULT_TOTAL,
                    currentPage:page,currentPageSize:pageSize}
                )

            })
            .catch(function (err) {
                console.log('err:', err);
                // POST failed...
            });



        // let data=tmpdeviceList.slice((page-1)*pageSize,((page-1)*pageSize)+pageSize)
        // this.setState({deviceList:data,currentPage:page,currentPageSize:pageSize})
        // console.log('onPageSizeChange',data)
    }


    handleChange = (event) => {
        var val = event.target.value;

        this.setState({
            poiName: val
        });

        // this.onPageSizeChange(this.state.currentPage,this.state.currentPageSize);
    }

    // getPOIList() {
    //     const name = this.state.poiName;
    //     const { token } = this.props;
    //     fetch("http://203.150.199.244/api/admin/getPOIList/1/20", {
    //         method: 'post',
    //         headers: {
    //             "Content-Type": "application/json; charset=utf-8",
    //            // "user_id": user_id,
    //            // "user_name": user_name,
    //            "token": token
    //         },
    //         body: JSON.stringify({
    //             "filter":name
    //         })
    //         })
    //         .then(response => response.json())
    //         .then(data => {
    //             this.setState({dataPoi:data.RESULT_DATA})

    //         })
    //         .catch(function (err) {
    //             console.log('err:', err);
    //             // POST failed...
    //         });


    //  }

    handleRowSelect1 = (row) => {
        const { onClickRowListTable } = this.props;
        onClickRowListTable(row)
    }

    // trStyle = (row, rowIndex) => {
    //     return { cursor: 'pointer'};
    // }

    editeDevice(device){

        this.setState({
            deviceSelectID:device.device_id,
            isShowEdit:true
        })
    }

    onEditDeviceClose(){
        this.btnEditClose.click();
        this.setState({
            isShowEdit:false
        })
    }

    deleteDevice(){

    }

    onClickSearch = () => {

        let name = this.state.poiName;

        this.setState({poiName:name});
        this.onPageSizeChange(this.state.currentPage,this.state.currentPageSize);
    }

  render() {
    const {deviceSelectID,isShowNew,isShowEdit,deviceList,currentPageSize}=this.state;

    const {  onClickDeletePoi } = this.props;
    const flattenData = this.state.dataPoi.map((item) => {

        return {
            id:item.poi_id,
            name: item.name,
            group: item.group,
            radius: item.radius,
            lat: item.location == undefined ? '' : item.location.latitude,
            lng: item.location == undefined ? '' : item.location.longitude,
            email:item.alert == undefined ? '':item.alert.email,
            line_token:item.alert == undefined ? '':item.alert.line_token,
            is_entry:item.alert == undefined ? '':item.alert.when.is_entry,
            is_leave:item.alert == undefined ? '':item.alert.when.is_leave,
            icon:item.icon,

          };
    });

        // const options = {
        //     page: 1,  // which page you want to show as default
        //     // sizePerPageList: [ {
        //     //   text: '5', value: 5
        //     // }, {
        //     //   text: '10', value: 10
        //     // }, {
        //     //   text: 'All', value: this.state.dataPoi.RESULT_TOTAL
        //     // } ], // you can change the dropdown list for size per page
        //     sizePerPage: 20,  // which size per page you want to locate as default
        //     pageStartIndex: 1, // where to start counting the pages
        //     paginationSize: 3,  // the pagination bar size.
        //     prePage: 'Prev', // Previous page button text
        //     nextPage: 'Next', // Next page button text
        //     firstPage: 'First', // First page button text
        //     lastPage: 'Last', // Last page button text
        //     //paginationShowsTotal: this.renderShowsTotal,  // Accept bool or function
        //     paginationPosition: 'bottom',  // default is bottom, top and both is all available
        //     hideSizePerPage: true,
        //     alwaysShowAllBtns: true, // Always show next and previous button
        //     withFirstAndLast: false, //> Hide the going to First and Last page button
        //     onRowClick: this.handleRowSelect1,

        //   };

          let rows = [];
          flattenData.map(device=>{
            rows.push(
                <tr key={device.id}>
                <td >{device.id}</td>
                <td >{device.group}</td>
                <td>{device.name}</td>
                <td>{device.lat}</td>
                <td>{device.lng}</td>
                <td  style={{textAlign:'center'}}>{device.radius}</td>
                <td style={{textAlign:'right'}}><p data-placement="top" data-toggle="tooltip" title="Edit">
                    <button onClick={this.handleRowSelect1.bind(this, device)} className="btn btn-primary btn-xs" data-title="Edit" data-toggle="modal"
                    data-target="#editDevice"  data-backdrop="static" data-keyboard="false"><span className="fa fa-pencil" /></button></p></td>
                    
                <td><p data-placement="top" data-toggle="tooltip" title="Delete">
                <button  onClick={(e) => { e.preventDefault(); onClickDeletePoi(device); }}  className="btn btn-danger btn-xs" data-title="Delete" data-toggle="modal"
                data-target="#deleteDevice" data-backdrop="static" data-keyboard="false"><span className="fa fa-trash" /></button></p></td>
                
                </tr>
            )

        });
    return (


        <div>

           <div className="form-inline">
                <label htmlFor="focusedInput" className="col-md-1">ค้นหา</label>
                
                <div  className="col-12 col-md-7 row" > 
                    <input id="focusedInput" className="form-control col-7 col-md-5 " style={{marginRight:5}}   type="text" onChange={this.handleChange} />
                    <input type="button" className="btn btn-info" value="ค้นหา" onClick={this.onClickSearch} />
                </div>
            </div>

            {/* <BootstrapTable data={ flattenData } trStyle={ this.trStyle } pagination={ true } options={ options } bordered={ false } hover striped >
                <TableHeaderColumn dataField='id' isKey width='40'>#</TableHeaderColumn>
                <TableHeaderColumn dataField='group' >กลุ่ม</TableHeaderColumn>
                <TableHeaderColumn dataField='name'>ชื่อ POI</TableHeaderColumn>
                <TableHeaderColumn dataField='lat' width='120'>Lat</TableHeaderColumn>
                <TableHeaderColumn dataField='lng' width='120'>Lng</TableHeaderColumn>
                <TableHeaderColumn dataField='radius'width='120'>รัศมี</TableHeaderColumn>
            </BootstrapTable> */}
            <div className="col-md-12 table-responsive" style={{marginTop:10}}>
                <table  className="table table-bordred table-striped table-hover ">
                <thead >
                    <tr>
                    <th>#</th>
                    <th style={{minWidth:100}}>กลุ่ม</th>
                    <th style={{minWidth:100}}>ชื่อ POI</th>
                    <th>latitude</th>
                    <th>longitude</th>
                    <th>รัศมี (เมตร)</th>
                    <th style={{width:50}}></th>
                    <th style={{width:50}}></th>
                    </tr></thead>
                <tbody>
                    {rows}
                </tbody>
                </table>

            </div>
            <RCPagination onSelect={this.onPageSelect.bind(this)} onShowSizeChange={this.onPageSizeChange.bind(this)} total={this.state.totalPage} pageSize={currentPageSize}/>
</div>
    );
  }
}

listPoi.propTypes = {
    onClickRowListTable: PropTypes.func.isRequired,
    userLevel: PropTypes.number.isRequired,
    user_name: PropTypes.string.isRequired,
    user_id: PropTypes.number.isRequired,
    token: PropTypes.string.isRequired,
    onClickCancelEditPoi: PropTypes.func.isRequired,
    onClickConfirmEditPoi: PropTypes.func.isRequired,
    onClickDeletePoi: PropTypes.func.isRequired,
    openAdd:PropTypes.func,
    openEdit:PropTypes.func,
}

export default listPoi;



// WEBPACK FOOTER //
// ./src/app/view/components/AdminConfig/Content/listPoi.js